<template>
  <div>
    <logged-in-header />
    <purchases ref="purchases" />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import purchases from "../components/purchases/Purchases";

export default {
  components: {
    loggedInHeader,
    purchases
  },

  beforeRouteLeave(to, from, next) {
    this.$refs.purchases.confirmLeave(next);
  }
};
</script>
